import SelectInputWithLabelT from '@components/tailwind-components/Input/SelectInputWithLabelT';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type TypeSelectorProps<T extends FieldValues> = {
  name: Path<T>;
  disabled?: boolean;
  control?: Control<T>;
};

export function TypeSelector<T extends FieldValues>({
  name,
  disabled,
  control,
}: TypeSelectorProps<T>) {
  const { t } = useTranslation();

  const TYPES = [
    {
      value: 'agent',
      description: t('handover-settings.filter.agent'),
    },
    {
      value: 'inbox',
      description: t('handover-settings.filter.inbox'),
    },
    {
      value: 'webclient',
      description: t('handover-settings.filter.webclient'),
    },
  ];

  return (
    <div className='min-w-[110px] max-w-[110px]'>
      <SelectInputWithLabelT
        label={t('handover-settings.interval.type')}
        field={name}
        values={TYPES}
        control={control}
        options={{
          disabled,
        }}
      />
    </div>
  );
}

export default TypeSelector;
